import { registerStyle } from '@wordpress/style-runtime';
if (typeof process === 'undefined' || process.env.NODE_ENV !== 'test') {
	registerStyle("8b2e8ca004", ".f9be9ef9523f77c6__trail{display:contents}.f9be9ef9523f77c6__trail li{margin-block-end:0}:has(>.f9be9ef9523f77c6__trail){min-inline-size:0}.f9be9ef9523f77c6__trail nav{min-inline-size:0}");
}
export default {"trail":"f9be9ef9523f77c6__trail"};
